import axios, { AxiosInstance } from 'axios'
import http from 'http'
import https from 'https'

/**
 * Instância axios dedicada a telas públicas (sem sessão) — hoje só a tela de
 * matrícula negociada (`/condicao-especial/:id`). Não usa `gatewayApi`
 * (`instancias-api.ts`) porque aquela instância:
 *   - fixa `Authorization: Bearer <token>` nos defaults, mesmo sem usuário
 *     logado;
 *   - tem interceptor que em 401 desloga (redirect `/entrar`) e em 403
 *     redireciona para `/403` — comportamento sem sentido numa tela sem
 *     sessão;
 *   - também emite toast genérico em 400, o que aqui atrapalharia: os 400 de
 *     negócio desta tela (link expirado, CPF divergente, proposta cancelada
 *     etc.) são os 6 estados de erro do briefing
 *     (docs/matricula-negociada/briefing-design-tela-aluno.md, seção 7) e
 *     precisam de UI própria, não de um toast solto.
 *
 * Ver docs/adr/0001-design-system-v2.md e regra 6 do checklist de PR lá
 * descrito.
 */
const httpAgent = new http.Agent({ keepAlive: true })
const httpsAgent = new https.Agent({ keepAlive: true })

export const apiPublica: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_URL_GATEWAY}/api`,
  responseType: 'json',
  httpAgent,
  httpsAgent
})
